module.exports = __webpack_public_path__ + "img/2.8c8dade1.png";